export default {
  // ========== Header ==========
  designTitle: 'Instructional Design',
  tabMethods: 'Instructional Models',
  tabStatuses: 'Statuses',
  statusEntity: 'Status',
  statusesHint:
    'These are the progress statuses an activity, a container or the whole design can have.',
  statusesEmpty: 'No statuses defined yet.',
  statusOrder: 'Order',
  statusOrderInvalid: 'Enter a number greater than or equal to 1.',
  statusOrderHint: 'Sets where it appears within the process.',
  statusColor: 'Color',
  statusActive: 'Active',
  statusActiveHint:
    'An inactive status is no longer offered, but pieces that already have it keep it.',
  statusDeleteWarning:
    'Activities, containers and designs with this status will be left without one. Nothing else is deleted.',
  methodEntity: 'Instructional Model',
  methodsEntity: 'Instructional Models',
  momentEntity: 'Instructional Moment',
  momentsEntity: 'Instructional Moments',

  // ========== Models table ==========
  fieldName: 'Name',
  fieldDescription: 'Description',
  fieldMoments: 'Moments',
  fieldOrder: 'Order',
  fieldColor: 'Color',
  momentsCount: 'No moments | 1 moment | {count} moments',
  manageMomentsTooltip: 'Manage the moments of this model',
  methodsEmpty:
    'There are no instructional models yet. Create the first one to enable the Instructional Design.',

  // ========== Moments ==========
  momentsModalTitle: 'Moments of {method}',
  momentsEmpty:
    'This model has no moments yet. Create the first one (for example: Activation, Demonstration, Application, Integration).',
  momentsHelp:
    'Moments are shown in the given order and group the Instructional Design activities.',
  momentNamePlaceholder: 'E.g.: Activation',

  // ========== Notices ==========
  deleteMethodWarning:
    'Its moments will be deleted too, and the activities using them will be left without an assigned moment.',
  deleteMomentWarning:
    'Instructional Design activities using this moment will be left without an assigned moment.',
  loadError: 'The instructional models could not be loaded. Please try again later.',
  saveError: 'Changes could not be saved. Please try again.',
  deleteError: 'It could not be deleted. Please try again.',
};
